import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseServiceV2 } from '@servicesv2';
import { ProdutoIBPTViewModel, ConsultaProdutoIBPTViewModel, ClassificacoesFiscaisIBPTDetalhesViewModel } from '../../models/atualizacao-ibpt/AtualizacaoIBPTViewModel';

@Injectable()
export class AdminServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('Admin', http);
  }

  consultaProdutoIBPT(payload: ConsultaProdutoIBPTViewModel) {
    return this.postAsPromise<ConsultaProdutoIBPTViewModel, ProdutoIBPTViewModel>(payload, 'consultaProdutoIBPT');
  }


  atualizarClassificacoesFiscaisIBPT(payload: ClassificacoesFiscaisIBPTDetalhesViewModel) {
    return this.postAsPromise<ClassificacoesFiscaisIBPTDetalhesViewModel, any>(payload, 'atualizarClassificacoesFiscaisIbpt');
  }
}
